import request from '@utils/request';

const getUrl = (path) => {
	const HOST = '//wx.hortor.net/gc/bigr/';
	return `${HOST}/${path}`;
};

const collect_api = {
	// 获取用户信息
	getUserInfo(params) {
		const url = getUrl('user');
		return request.get(url, { params });
	},
	// 提交审核
	toSubmit(params) {
		const url = getUrl('submit');

		return request.post(url, { data: params, requestType: 'form' });
	},
};

export default collect_api;
